function splitCsvRow(row) {
  const values=[];
  let value='';
  let quoted=false;

  for (let index=0;index<row.length;index+=1) {
    const character=row[index];

    if (character==='"' && row[index+1]==='"') {
      value+='"';
      index+=1;
    } else if (character==='"') {
      quoted=!quoted;
    } else if (character===',' && !quoted) {
      values.push(value.trim());
      value='';
    } else {
      value+=character;
    }
  }

  values.push(value.trim());
  return values;
}

function splitCsvLines(text) {
  const lines=[];
  let line='';
  let quoted=false;

  for (let index=0;index<text.length;index+=1) {
    const character=text[index];

    if (character==='"') {
      if (text[index+1]==='"') {
        line+='"';
        index+=1;
      } else {
        quoted=!quoted;
        line+=character;
      }
    } else if ((character==='\n' || character==='\r') && !quoted) {
      if (line.trim()) {
        lines.push(line);
      }
      line='';
      if (character==='\r' && text[index+1]==='\n') {
        index+=1;
      }
    } else {
      line+=character;
    }
  }

  if (line.trim()) {
    lines.push(line);
  }

  return lines;
}

export function parseCsv(text) {
  const rows=splitCsvLines(text.replace(/^\uFEFF/,''));

  if (rows.length<2) {
    return [];
  }

  const headers=splitCsvRow(rows[0]).map((header)=> header.trim());

  return rows.slice(1).map((row)=> {
    const values=splitCsvRow(row);

    return headers.reduce((record,header,index)=> {
      record[header]=values[index] || '';
      return record;
    },{});
  });
}